import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Tooltip, TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-info-tooltip',
    templateUrl: './info-tooltip.component.html',
    styleUrls: ['./info-tooltip.component.scss'],
    standalone: true,
    imports: [TooltipModule, TranslateModule],
})
export class InfoTooltipComponent implements OnInit {
    @Input({ required: true }) id: string = '';
    @Input({ required: true }) iconClass: string = '';
    @Input({ required: false }) tooltipText: string = '';
    @Input({ required: false }) tooltipTextSize: 'xl' | 'lg' | 'sm' = 'sm';
    @Input({ required: false }) position: 'right' | 'left' | 'bottom' | 'top' = 'right';

    @Input({ required: false }) tooltipDisabled: boolean = false;
    @Input({ required: false }) tooltipEscape: boolean = true;
    @Input({ required: false }) ellipsisCharacterLength: number = 0;
    @Input({ required: false }) tabindex: number = 0;

    @ViewChild(Tooltip) tooltipEl!: Tooltip;

    styleClass: string = '';

    readonly screenWidth: number = window.innerWidth;

    activateTooltip(event: Event) {
        if (this.tooltipDisabled) {
            return;
        }
        this.tooltipEl.activate();
        event.stopPropagation();
    }

    deactivateTooltip(event: Event) {
        this.tooltipEl.deactivate();
        event.stopPropagation();
    }

    ngOnInit(): void {
        if (!this.tooltipText) {
            this.styleClass = 'lg-info-tooltip tooltip-content';
        }
        if (this.tooltipText?.length > 500 || this.tooltipTextSize === 'xl') {
            this.styleClass = 'xl-info-tooltip';
        } else if (this.tooltipText?.length > 150 || this.tooltipTextSize === 'lg') {
            this.styleClass = 'lg-info-tooltip';
        } else if (this.tooltipTextSize === 'sm') {
            this.styleClass = 'sm-info-tooltip';
        }
        if (this.ellipsisCharacterLength > 0) {
            this.displayEllipsisOnTooltip();
        }
    }

    stopPropagation(event: Event) {
        event.stopPropagation();
    }

    displayEllipsisOnTooltip() {
        if (this.tooltipText?.length > this.ellipsisCharacterLength) {
            this.styleClass = 'ellipsis-tooltip';
        }
    }
}
